"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYearlyScheduleInfoItemsCreatorTexts = void 0;
require("../../../core");
require("../types");
const getYearlyScheduleInfoItemsCreatorTexts = (t) => {
    return {
        yearlySettingsLabel: t('scheduleInfo|form|fields|yearlySettings|label'),
        yearlySettingsFilled: t('scheduleInfo|form|fields|yearlySettings|filled'),
        yearlyRetentionCountLabel: t('scheduleInfo|form|fields|yearlyRetentionCount|label'),
        storageClassS3: t('scheduleInfo|storageClass|s3'),
        storageClassLabel: t('scheduleInfo|form|fields|repository|storageClassLabel'),
        repositoryLabel: t('scheduleInfo|form|fields|repository|label'),
        january: t('scheduleControl|month|january'),
        february: t('scheduleControl|month|february'),
        march: t('scheduleControl|month|march'),
        april: t('scheduleControl|month|april'),
        may: t('scheduleControl|month|may'),
        june: t('scheduleControl|month|june'),
        july: t('scheduleControl|month|july'),
        august: t('scheduleControl|month|august'),
        september: t('scheduleControl|month|september'),
        october: t('scheduleControl|month|october'),
        november: t('scheduleControl|month|november'),
        december: t('scheduleControl|month|december'),
        first: t('scheduleControl|dayNumberInMonth|first'),
        second: t('scheduleControl|dayNumberInMonth|second'),
        third: t('scheduleControl|dayNumberInMonth|third'),
        fourth: t('scheduleControl|dayNumberInMonth|fourth'),
        last: t('scheduleControl|dayNumberInMonth|last'),
        onDay: t('scheduleControl|dayNumberInMonth|onDay'),
        onLastDay: t('scheduleControl|dayNumberInMonth|onLastDay'),
        sunday: t('scheduleControl|daysOfWeek|sunday'),
        monday: t('scheduleControl|daysOfWeek|monday'),
        tuesday: t('scheduleControl|daysOfWeek|tuesday'),
        wednesday: t('scheduleControl|daysOfWeek|wednesday'),
        thursday: t('scheduleControl|daysOfWeek|thursday'),
        friday: t('scheduleControl|daysOfWeek|friday'),
        saturday: t('scheduleControl|daysOfWeek|saturday'),
        lastDay: t('scheduleControl|dayOfMonth|lastDay'),
        unitsLabelDaysSingular: t('scheduleInfo|unitsLabel|days|singular'),
        unitsLabelDaysPlural: t('scheduleInfo|unitsLabel|days|plural'),
        unitsLabelMonthsSingular: t('scheduleInfo|unitsLabel|months|singular'),
        unitsLabelMonthsPlural: t('scheduleInfo|unitsLabel|months|plural'),
        unitsLabelYearsSingular: t('scheduleInfo|unitsLabel|years|singular'),
        unitsLabelYearsPlural: t('scheduleInfo|unitsLabel|years|plural'),
    };
};
exports.getYearlyScheduleInfoItemsCreatorTexts = getYearlyScheduleInfoItemsCreatorTexts;
//# sourceMappingURL=getYearlyScheduleInfoItemsCreatorTexts.js.map